import React, { useState, useEffect } from "react";
import {
  Table,
  Spinner,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { deviceDataAPI } from "../services/Device";
import TableHeader from "components/TableHeader";

const deviceCache = {
  data: null,
  timestamp: null,
};
const NonCompliance = () => {
  const [deviceData, setDeviceData] = useState([]);

  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterBy, setFilterBy] = useState("Site Name");
  const [searchValue, setSearchValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 50;

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const totalPages = Math.ceil(searchData.length / recordsPerPage);

  const handleToggle = () => {
    setIsOpen(!isOpen); // Toggle the dropdown's open status
  };
  const refreshlist = () => {
    setLoading(true);
    document.getElementById("refreshbtn").className = "fas fa-sync fa-spin";
    deviceCache.data = null;
    getAllDevice(false, true);
  };

  const applyFilters = () => {
    let filteredList = deviceData;
    if (searchValue) {
      filteredList = deviceData?.filter((item) => {
        if (filterBy === "Site Name") {
          return item?.clinicName
            ?.toLowerCase()
            ?.includes(searchValue?.toLowerCase());
        } else if (filterBy === "Activation Date") {
          return timeFormatMinSec(item?.createdAt).includes(searchValue);
        }
      });
    }
    setSearchData(filteredList);
  };
  const handleFilterByChange = (value) => {
    setSearchValue("");
    setFilterBy(value);
  };

  // Event handler for search input change
  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  useEffect(() => {
    applyFilters();
  }, [filterBy, searchValue]);

  const downloadCSV = (csv, filename) => {
    var csvFile;
    var downloadLink;

    //define the file type to text/csv
    csvFile = new Blob([csv], { type: "text/csv" });
    downloadLink = document.createElement("a");
    downloadLink.download = filename;
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";

    document.body.appendChild(downloadLink);
    downloadLink.click();
  };
  const exportTableToCSV = () => {
    //declare a JavaScript letiable of array type
    let csv = [];
    let rows = document.querySelectorAll("table tr");

    //merge the whole data in tabular form
    for (let i = 0; i < rows.length; i++) {
      let row = [],
        cols = rows[i].querySelectorAll("td, th");
      for (let j = 0; j < cols.length; j++) row.push(cols[j].innerText);
      csv.push(row.join(","));
    }
    //call the function to download the CSV file
    let filename = "NonCompliant";
    downloadCSV(csv.join("\n"), filename);
  };

  const getAllDevice = async (isBackground = false, isMounted = true) => {
    try {
      if (!isBackground) setLoading(true);

      const data = await deviceDataAPI();

      if (!isMounted) return;
      if (data.success && Array.isArray(data.devices)) {
        deviceCache.data = data.devices;
        deviceCache.timestamp = Date.now();
        setDeviceData(data.devices);
        setSearchData(data.devices);
        setLoading(false);
        document.getElementById("refreshbtn").className = "fas fa-sync fa-stop";
      } else {
        console.warn("No devices found:", data);
        setDeviceData([]);
        setSearchData([]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Failed to load non-compliant devices:", error);
      if (isMounted) {
        setDeviceData([]);
        setSearchData([]);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    let isMounted = true;

    if (deviceCache.data) {
      setDeviceData(deviceCache.data);
      setSearchData(deviceCache.data);
      getAllDevice(true, isMounted);
    } else {
      getAllDevice(false, isMounted);
    }

    return () => {
      isMounted = false;
    };
  }, []);

  const timeFormatMinSec = (dateStr) => {
    if (
      typeof dateStr == "undefined" ||
      dateStr == undefined ||
      dateStr == "undefined" ||
      dateStr < 1520160669214
    ) {
      return " ";
    }
    let date = new Date(parseInt(dateStr));
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime =
      (" 0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2) + " " + ampm;
    let newDate = new Date(parseInt(dateStr)).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    return newDate + " (" + strTime + ")";
  };

  const handleSort = (column) => {
    if (sortColumn === column) {
      // Toggle sorting order if the same column is clicked again
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };
  const deviceListRecords = () => {
    let sortedList = [...searchData];
    if (sortColumn) {
      sortedList?.sort((a, b) => {
        if (sortOrder === "asc") {
          return a[sortColumn]?.toString()?.localeCompare(b[sortColumn]);
        } else {
          return b[sortColumn]?.toString()?.localeCompare(a[sortColumn]);
        }
      });
    }
    let currentDate = new Date();
    let nonCompliantSubjects = sortedList?.filter((item) => {
      let updatedAtDate = new Date(item?.updatedAt);
      let timeDifferenceInDays = Math.floor(
        (currentDate - updatedAtDate) / (1000 * 60 * 60 * 24),
      );
      return timeDifferenceInDays > 2;
    });
    let paginatedData = nonCompliantSubjects.slice(
      indexOfFirstRecord,
      indexOfLastRecord,
    );
    if (paginatedData?.length > 0 && !loading) {
      return paginatedData.map((item, index) => (
        <tr key={index}>
          <td style={{ textAlign: "left" }}>{item?.subjectId || "-"}</td>
          <td style={{ textAlign: "left" }}>{item?.clinicName || "-"}</td>
          <td style={{ textAlign: "left" }}>
            <a href={"/#/device/" + item?.id}>{item?.prcId || "-"}</a>
          </td>
          <td style={{ textAlign: "left" }}>
            {timeFormatMinSec(item?.createdAt) || "-"}
          </td>
          <td style={{ textAlign: "left" }}>
            {timeFormatMinSec(item?.updatedAt) || "-"}
          </td>
        </tr>
      ));
    } else {
      return (
        <>
          {loading ? (
            <tr>
              <td
                colSpan="5"
                style={{ textAlign: "center", padding: "60px 0" }}
              >
                <Spinner
                  animation="border"
                  style={{
                    width: "2.5rem",
                    height: "2.5rem",
                    color: "#525f7f",
                  }}
                />
                <div style={{ marginTop: 12, color: "#6c757d", fontSize: 14 }}>
                  Loading Data...
                </div>
              </td>
            </tr>
          ) : (
            <tr>
              <th colSpan="12" style={{ textAlign: "center" }}>
                No Record Found!
              </th>
            </tr>
          )}
        </>
      );
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", background: "#fff", height: "100vh", overflow: "hidden" }}>
      <TableHeader
        title="Non-Compliant Subjects (Daily Uploads)"
        onRefresh={refreshlist}
        onDownload={exportTableToCSV}
        totalCount={searchData.length > 0 ? searchData.length : null}
        hasMore={false}
       filterContent={
  <div style={{ display: "flex", gap: 8, alignItems: "center" , maxWidth: 500}}>
    <Dropdown isOpen={isOpen} toggle={handleToggle} style={{ flexShrink: 0 }}>
      <DropdownToggle caret>Filter By: {filterBy}</DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => handleFilterByChange("Site Name")}>Site Name</DropdownItem>
        <DropdownItem onClick={() => handleFilterByChange("Activation Date")}>Activation Date</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Input
      type="text"
      placeholder={`Enter ${filterBy}`}
      value={searchValue}
      onChange={handleSearchInputChange}
      style={{ flex: 1 }}
    />
  </div>
}
      />

      <div style={{ overflowY: "auto", background: "#fff" }}>
        <Table
          striped
          hover
          responsive
          bordered
          className="align-items-center table-flush"
          style={{ margin: 0 }}
        >
          <thead
            className="thead-light"
            style={{ cursor: "pointer", position: "sticky", top: 0, zIndex: 1 }}
          >
            <tr>
              <th
                scope="col"
                style={{ textAlign: "left" }}
                onClick={() => handleSort("subjectId")}
              >
                Subject Id
              </th>
              <th
                scope="col"
                style={{ textAlign: "left" }}
                onClick={() => handleSort("clinicName")}
              >
                Clinic Name
              </th>
              <th
                scope="col"
                style={{ textAlign: "left" }}
                onClick={() => handleSort("prcId")}
              >
                Ring Id
              </th>
              <th
                scope="col"
                style={{ textAlign: "left" }}
                onClick={() => handleSort("createdAt")}
              >
                Activation Date
              </th>
              <th
                scope="col"
                style={{ textAlign: "left" }}
                onClick={() => handleSort("updatedAt")}
              >
                Last Sync Date
              </th>
            </tr>
          </thead>
          <tbody>
            {deviceListRecords()}
            {searchData.length > 50 && !loading && (
              <tr>
                <td
                  colSpan="5"
                  style={{ textAlign: "right", padding: "12px 16px" }}
                >
                  <div
                    style={{
                      display: "inline-flex",
                      gap: 8,
                      alignItems: "center",
                    }}
                  >
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((prev) => prev - 1)}
                      style={{
                        padding: "6px 14px",
                        borderRadius: 6,
                        border: "1px solid #dee2e6",
                        background: currentPage === 1 ? "#f8f9fa" : "#fff",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        fontWeight: 500,
                      }}
                    >
                      ←
                    </button>
                    <div
                      style={{
                        padding: "6px 14px",
                        borderRadius: 6,
                        background: "#f2f0f0",
                        color: "#0e0d0d",
                        fontWeight: 500,
                        fontSize: 14,
                      }}
                    >
                      {indexOfFirstRecord + 1}–
                      {Math.min(indexOfLastRecord, searchData.length)} of{" "}
                      {searchData.length}
                    </div>
                    <button
                      disabled={currentPage === totalPages || totalPages === 0}
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      style={{
                        padding: "6px 14px",
                        borderRadius: 6,
                        border: "1px solid #dee2e6",
                        background:
                          currentPage === totalPages ? "#f8f9fa" : "#fff",
                        cursor:
                          currentPage === totalPages
                            ? "not-allowed"
                            : "pointer",
                        fontWeight: 500,
                      }}
                    >
                      →
                    </button>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default NonCompliance;
